export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass - สตรีมการแข่งขัน NBA สด | NBA.com',
	seo_meta_desc_leaguepass: 'สตรีมการแข่งขัน NBA แบบสดๆ และแบบย้อนหลังด้วย League Pass เข้าถึงบัญชีของคุณที่นี่',
	seo_meta_keywords_leaguepass: 'วิดีโอ NBA, ไฮไลท์ NBA, วิดีโอบาสเกตบอล, การเล่นที่ยอดเยี่ยม, การดังค์, รายการแนะนำ',
	seo_meta_title_featured: 'สตรีมการแข่งขัน NBA และชมไฮไลท์ | NBA.com',
	seo_meta_desc_featured: 'ชมวิดีโอไฮไลท์การแข่งขัน ข่าวและบทวิเคราะห์ของ NBA โดยไม่มีค่าใช้จ่าย  นอกจากนี้ สำรวจการเป็นสมาชิก NBA TV & League Pass เพื่อรับชมการแข่งขันสดบนอุปกรณ์ที่คุณชื่นชอบ',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV - สตรีมการแข่งขันสดและรายงานข่าวตลอดเวลา | NBA.com',
	seo_meta_desc_nbatv: 'สตรีมการแข่งขัน NBA TV แบบสดๆ หรือชมการแข่งขันคลาสสิกที่เป็นตำนาน นอกจากนี้ยังเข้าถึงรายการทางสตูดิโอและบทวิเคราะห์จากทั่วทั้งลีกได้ด้วย',
	seo_meta_keywords_nbatv: 'คุณสามารถรับชมการแข่งขันผ่านรายการต่างๆ ดังนี้ NBA TV Channel, The Beat, Hardwood Classics, NBA Live, Real NBA, NBA Gametime, Fantasy Insider, Studio Shows, The Jump',
	seo_meta_title_classicgames: 'สตรีมการแข่งขันคลาสสิกด้วย NBA TV และอื่นๆ | NBA.com',
	seo_meta_desc_classicgames: 'สตรีมการแข่งขัน NBA ที่เป็นตำนานด้วย NBA TV นอกจากนี้ยังสตรีมสดการแข่งขันทาง NBA TV และเข้าถึงรายการทางสตูดิโอและบทวิเคราะห์จากทั่วทั้งลีกได้ด้วย',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: 'สตรีมเนื้อหาที่นี่ | NBA.com',
	seo_meta_title_videolist: 'สตรีม {0} ที่นี่ | NBA.com',
	seo_meta_desc_videolist: 'ชมวิดีโอ {0} ที่นี่  นอกจากนี้ ไปสำรวจการเป็นสมาชิก NBA TV & League Pass เพื่อรับชมการแข่งขันสดบนอุปกรณ์ที่คุณชื่นชอบ',
	seo_meta_title_videolist_show: 'สตรีม {0} ด้วย NBA TV | NBA.com',
	seo_meta_desc_videolist_show: 'รับชม {0} ที่นี่ นอกจากนี้ สตรีมการแข่งขันสดบน NBA TV และเข้าถึงการแข่งขันคลาสสิกและการวิเคราะห์ได้ด้วย',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: 'สตรีม {0} ที่นี่ | NBA.com',
	seo_meta_desc_videolist_feed: 'ชมวิดีโอ {0} ที่นี่ นอกจากนี้ ไปสำรวจการเป็นสมาชิก NBA TV & League Pass เพื่อรับชมการแข่งขันสดบนอุปกรณ์ที่คุณชื่นชอบ',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'สตรีมรายการของสตูดิโอด้วย NBA TV และอื่น ๆ | NBA.com',
	seo_meta_desc_shows: 'สำรวจและสตรีมรายการต่างๆ ล่าสุดของ NBA TV และตอนอื่นๆ แบบย้อนหลัง นอกจากนี้ สตรีมการแข่งขันสดบน NBA TV และเข้าถึงการแข่งขันคลาสสิกและบทวิเคราะห์',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: 'หน้าแรก | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'ช่องต่างๆ | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'ช่อง | NBA.com',
	seo_meta_pre_title_categories: 'หมวดหมู่ต่างๆ | NBA.com',
	seo_meta_title_categories: 'หมวดหมู่ต่างๆ | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'หมวดหมู่ | NBA.com',
	seo_meta_title_category: 'หมวดหมู่ | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'สตรีมวิดีโอที่นี่ | NBA.com',
	seo_meta_pre_title_event: 'สตรีมกิจกรรมที่นี่ | NBA.com',
	seo_meta_title_events: 'กิจกรรมต่างๆ | NBA.com',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'สตรีม {0} ที่นี่ | NBA.com',
	seo_meta_desc_event: 'รับชม {0} ที่นี่ นอกจากนี้ สำรวจการเป็นสมาชิก NBA TV & League Pass เพื่อรับชมการแข่งขันสดบนอุปกรณ์ที่คุณชื่นชอบ',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'ค้นหา | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'ไม่พบหน้านี้ | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'สตรีมการแข่งขันที่นี่ | NBA.com',
	seo_meta_title_game: 'สตรีม {0} ที่นี่ | NBA.com',
	seo_meta_desc_game: 'รับชม {0} ที่นี่ นอกจากนี้ สำรวจการเป็นสมาชิก NBA TV & League Pass เพื่อรับชมการแข่งขันสดบนอุปกรณ์ที่คุณชื่นชอบ',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'สตรีม {0} ที่นี่ | NBA.com',
	seo_meta_desc_video: 'รับชม {0} ที่นี่ นอกจากนี้ สำรวจการเป็นสมาชิก NBA TV & League Pass เพื่อรับชมการแข่งขันสดบนอุปกรณ์ที่คุณชื่นชอบ',
	seo_meta_keywords_video: 'วิดีโอ NBA, ไฮไลท์ NBA, วิดีโอบาสเกตบอล, การเล่นที่ยอดเยี่ยม, การดังค์, รายการแนะนำ',
	seo_meta_title_episode: 'สตรีม {0} ด้วย NBA TV | NBA.com',
	seo_meta_desc_episode: 'รับชม {0} ที่นี่ นอกจากนี้ สตรีมการแข่งขันบน NBA TV แบบสดๆ และเข้าถึงการแข่งขันคลาสสิกและบทวิเคราะห์',
	seo_meta_keywords_episode: 'วิดีโอ NBA, ไฮไลท์ NBA, วิดีโอบาสเกตบอล, การเล่นที่ยอดเยี่ยม, การดังค์, รายการแนะนำ',
	seo_meta_title_channel: 'การถ่ายทอดสดทาง NBA TV | NBA.com',
	seo_meta_desc_channel: 'NBA TV Live คือการสตรีมรายการตลอด 24 ชั่วโมงต่อวันของ NBA TV Channel ถ่ายทอดการแข่งขัน NBA ทุกสัปดาห์ทั้งแบบถ่ายทอดสดและย้อนหลัง โปรแกรมในสตูดิโอและการรายงานข้อมูลจากนักวิเคราะห์',
	seo_meta_keywords_channel: 'คุณสามารถรับชมการแข่งขันผ่านรายการต่างๆ ดังนี้ NBA TV Channel, The Beat, Hardwood Classics, NBA Live, Real NBA, NBA Gametime, Fantasy Insider, Studio Shows, The Jump',
	seo_meta_title_tvguide: 'กำหนดการสตรีมสดของ NBA TV | NBA.com',
	seo_meta_desc_tvguide: 'ดูว่าคุณสามารถสตรีมการแข่งขัน NBA TV แบบสดและรายการสดในสตูดิโอด้วย NBA TV บนอุปกรณ์โปรดของคุณได้เมื่อใด นอกจากนี้ยังเข้าถึงรายการสตูดิโอย้อนหลังและการวิเคราะห์',
	seo_meta_keywords_tvguide: 'คุณสามารถรับชมการแข่งขันผ่านรายการต่างๆ ดังนี้ NBA TV Channel, The Beat, Hardwood Classics, NBA Live, Real NBA, NBA Gametime, Fantasy Insider, Studio Shows, The Jump',

	// Common
	timezone: 'ET',
	default_feed_error_message: 'เกิดข้อผิดพลาด เนื้อหาไม่พร้อมใช้งานในขณะนี้  คุณอาจจะลองดูใหม่อีกครั้ง',
	watch_in_app: 'รับชมบนแอป NBA',
	ad_blocked_message: 'ตรวจพบ Ad Blocker: เนื้อหา NBA.com ได้รับการสนับสนุนโดยการโฆษณา หากต้องการเพลิดเพลินกับเนื้อหาของเราต่อ โปรดปิดตัวบล็อกโฆษณาของคุณ',

	// Item
	no_content: 'ไม่มีเนื้อหา',
	see_more: 'ดูเพิ่มเติม',
	now_playing: 'กำลังเล่น',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'LEAGUE PASS',
	league_pass_premium_lock: 'LP ระดับพรีเมี่ยม',
	error_max_limit_favorite: 'คุณมีวิดีโอโปรดครบตามจำนวนสูงสุดแล้ว โปรดลบวิดีโอโปรดบางรายการออกก่อนที่จะเพิ่มวิดีโอใหม่',
	item_live: 'ถ่ายทอดสด:',
	add_favourite_title: 'เพิ่มในรายการโปรด',
	remove_favourite_title: 'ลบออกจากรายการโปรด',
	// Channel: Schedule
	p_channel_live: 'ถ่ายทอดสด:',
	p_channel_schedule_title: 'ตาราง NBA TV',
	p_channel_schedule_watch: 'ชม',
	p_channel_live24x7_title: 'NBA TV 24/7',
	p_channel_live24x7_see_full_schedule: 'ดูตารางทั้งหมด',
	p_channel_live24x7_up_next: 'ถัดไป',
	p_channel_live24x7_on_demand: 'NBA TV: ออนดีมานด์',
	p_channel_live24x7_collection: 'คอลเลกชั่น',
	p_channel_live24x7_demand_1_logo_text: 'รายการปกติ',
	p_channel_live24x7_demand_1_show_name: 'รายการต่างๆ ของ NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'รายการต่างๆ ของ NBA TV ตามปกติรวมถึง Shaqtin \'a Fool, Beyond the Paint, Game Time และ Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'เกมคลาสสิก',
	p_channel_live24x7_demand_2_show_name: 'NBA | การแข่งขันคลาสสิก',
	p_channel_live24x7_demand_2_show_desc: 'ชมการแข่งขันคลาสสิกแบบเต็มเกม รวมถึงคู่ชิงชนะเลิศทุกคู่ตั้งแต่ปี 2000 ช่วงเวลาแห่งประวัติศาสตร์ของลีก และผู้เล่นที่เป็นตำนาน',

	// Channel: Clips
	p_channel_error_msg: 'ยังไม่มีจำหน่าย',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'ตารางเวลา',

	// NBA TV Shows:
	p_nba_tv_shows: 'รายการต่างๆ ของ NBA TV',
	p_nba_tv_no_access_title: '24/7 NBA : คอยรับข้อมูลการวิเคราะห์การแข่งขัน การวิเคราะห์จากห้องส่ง รายการปกติ และอีกมากมาย!',
	p_nba_tv_no_access_desc: 'ชมการแข่งขันสดๆ และรายการต่างๆ รวมถึงการแข่งขันสุดคลาสสิกได้ตามต้องการ',
	p_nba_tv_no_access_note: 'อาจมีการระงับสัญญาณภาพ',

	// tv show item
	tv_show_item_latest_episode: 'ตอนล่าสุด',
	tv_show_item_no_latest_episode: 'ไม่มีตอนล่าสุด',
	see_all: 'ดูทั้งหมด',
	// header
	header_menu_watch: 'ชม',
	header_menu_featured: 'รายการเด่น',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'LEAGUE PASS',

	// search
	players: 'ผู้เล่น',
	videos: 'วิดีโอ',
	teams: 'ทีม',
	most_searched: 'ถูกค้นหามากที่สุด',
	no_result: 'ไม่มีข้อมูล',
	search_filter_type_most_relevant: 'มีความเกี่ยวข้องมากที่สุด',
	search_filter_type_most_viewed: 'มีการรับชมมากที่สุด',
	search_filter_type_most_recent: 'ล่าสุด',
	search_filter_type_last_30_days: '30 วันที่ผ่านมา',
	search_filter_type_last_6_months: '6 เดือนที่ผ่านมา',
	search_result_label: 'ผลการค้นหาสำหรับ \'{keyword}\'',
	search_result_info: 'ดูผลลัพธ์ทั้งหมดสำหรับ {keyword}',
	search_placeholder: 'ค้นหาไลบรารีวิดีโอ',
	load_more: 'โหลดเพิ่ม...',

	// button
	button_subscribe: 'สมัครรับบริการ',
	button_sign_in: 'ลงชื่อเข้าใช้',
	button_tv_provider: 'เลือกผู้ให้บริการทีวี',

	// league page
	p_league_pass_no_access_title: 'ชมการแข่งขันสดหรือรีเพลย์บนอุปกรณ์ไหนก็ได้ รวมถึงคอมพิวเตอร์ สมาร์ทโฟนและทีวี!',
	p_league_pass_no_access_desc: 'ตั๋วสู่ความมันส์: จะดูทั้งลีกหรือดูทีมโปรดของคุณก็ได้ เลือกการแข่งขันเดียวหรือดูตัวเลือกอื่นเพิ่มเติม',
	p_league_pass_no_access_note: 'เป็นไปตามข้อกำหนด',

	// Video
	category_title: 'วิดีโอ',
	p_video_playlist_title: 'เพลย์ลิสต์',
	p_video_episode_text: 'ตอน',
	p_no_access_league_pass_title: 'ปลดล็อก NBA League Pass เพื่อรับชม:',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: 'ตั๋วสู่ความมันส์: จะดูทั้งลีกหรือดูทีมโปรดของคุณก็ได้ เลือกการแข่งขันเดียวหรือดูตัวเลือกอื่นเพิ่มเติม',
	p_no_access_league_pass_terms: 'เป็นไปตามข้อกำหนด',
	p_no_access_league_pass_geo_desc: 'จากตำแหน่งปัจจุบันของคุณ คุณไม่สามารถดูการแข่งขันนี้ผ่าน NBA League Pass และ NBA TV ได้ ไฟล์เก็บถาวรของการแข่งขันเหล่านี้จะพร้อมใช้งาน 3 วันหลังจากออกอากาศสำหรับสมาชิก NBA League Pass โปรดสอบถามผู้กระจายเสียงทางวิทยุและโทรทัศน์ในพื้นที่เรื่องตารางออกอากาศเพื่อหาช่องทางการถ่ายทอดการแข่งขันในพื้นที่ของคุณ',
	p_no_access_league_pass_not_found_desc: 'ขออภัย ไม่พบวิดีโอที่คุณต้องการ',
	p_no_access_event_geo_desc: 'การออกอากาศนี้ไม่สามารถดูได้สำหรับแฟนๆ ในสหรัฐอเมริกาหรือแคนาดา หากต้องการรับชมโปรดติดตาม ESPN ในสหรัฐอเมริกาและ TSN หรือ Sportsnet ในแคนาดา',
	p_no_access_event_not_found_desc: 'ขออภัย ไม่พบกิจกรรมที่คุณต้องการ',
	p_no_access_nba_tv_title: 'ปลดล็อก NBA TV เพื่อรับชม:',
	p_no_access_nba_tv_desc: 'ชมการแข่งขันสดและรายการต่างๆ รวมถึงการแข่งขันคลาสสิกได้ตามต้องการ',
	p_no_access_nba_tv_terms: 'เป็นไปตามข้อกำหนด',
	p_no_access_nba_tv_geo_desc: 'จากตำแหน่งปัจจุบันของคุณคุณไม่สามารถดูการแข่งขันนี้ผ่าน NBA League Pass และ NBA TV ได้ ไฟล์เก็บถาวรของการแข่งขันเหล่านี้จะพร้อมรับชมในอีก 3 วันหลังจากออกอากาศสำหรับสมาชิก NBA League Pass โปรดสอบถามผู้กระจายเสียงทางวิทยุและโทรทัศน์ในพื้นที่เรื่องตารางออกอากาศเพื่อหาช่องทางการถ่ายทอดการแข่งขันในพื้นที่ของคุณ',
	p_no_access_nba_tv_not_found_desc: 'ขออภัย ไม่พบช่องที่คุณต้องการ',
	p_no_access_up_next: 'ถัดไป:',
	p_video_completed_title: 'เพลย์ลิสต์เสร็จสมบูรณ์',
	p_video_completed_desc: 'กลับไปเรียกดูหรือดูเพลย์ลิสต์ถัดไปสำหรับคุณ',
	p_video_share_to: 'แชร์ไปที่:',
	p_video_more_to_watch: 'ดูเพิ่ม:',

	// Event
	p_event_section_title: 'กิจกรรม',
	p_event_playlist_title: 'เพลย์ลิสต์',
	p_event_button_watch: 'ชม',
	p_event_button_listen: 'ฟัง',
	p_event_button_ticket: 'ตั๋ว',

	// notfound page
	notfound: 'ขออภัย ไม่พบหน้าที่คุณต้องการ',
	notfound_desc: 'โปรดตรวจสอบ URL เพื่อหาข้อผิดพลาด<br/> นอกจากนี้คุณยังสามารถค้นหาเนื้อหาของคุณได้โดยใช้ระบบนำทางในเว็บไซต์หรือเครื่องมือค้นหา',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'บัญชี NBA League Pass ของคุณมีการสตรีมบนอุปกรณ์เกินจำนวนที่กำหนด กรุณาแตะ \'ดำเนินการต่อ\' เพื่อดูต่อบนอุปกรณ์นี้',
	modal_pcm_custom: 'ดำเนินการต่อ',
	modal_pcm_close: 'ยกเลิก',
	modal_pcm_ok: 'ตกลง',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'วิดีโอนี้ไม่สามารถเล่นบนอุปกรณ์ของคุณ คลิก <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>ที่นี่</a> เพื่อรับความช่วยเหลือเพิ่มเติม',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'ตกลง',
	modal_video_unsupported_ok: 'ตกลง',

	// FreeSample
	freesample_notice_time: 'เวลาที่เหลือ',
	freesample_notice_title: 'เพลิดเพลินไปกับการเข้าถึง {0} นาที',
	freesample_notice_desc: 'สมัครรับบริการแพ็กเกจ League Pass แบบเต็มรูปแบบเพื่อเข้าถึงเนื้อหาต่อไปหลังจากครบ 10 {0} นาที',
	freesample_notice_subscribe_button: 'สมัครรับบริการ',
	freesample_notice_cancel_button: 'ยกเลิกได้ทุกเมื่อ',
	freesample_popup_title: 'สิทธิ์การเข้าถึงของคุณสิ้นสุดแล้ว',
	freesample_popup_subtitle: 'สมัครรับบริการ League Pass เพื่อชมเนื้อหา NBA ที่น่าสนใจอื่นๆ',
	freesample_popup_link: 'เรียนรู้เพิ่มเติม!',
	freesample_popup_get_minutes_button: 'รับสิทธิ์ {0}  นาที',

	// Video list
	reg_required_desc: 'คุณต้องลงชื่อเข้าใช้เพื่อดูเนื้อหานี้',
	favorite_teams_title: 'ทีมโปรด',
	bookmarked_title: 'บันทึกแล้ว',
	watch_history_title: 'ดูต่อ',
	game_schedule_title: 'ตารางการแข่งขัน',
	recommended_title: 'แนะนำ',
	season_text: 'ฤดูกาล',

	// profile page
	section_information_title: 'ข้อมูลของฉัน',
	section_information_desc: 'อัปเดตข้อมูลส่วนบุคคลของคุณ',
	section_information_email: 'อีเมล',
	section_information_email_update: 'อัปเดตที่อยู่อีเมล',
	section_information_password: 'รหัสผ่าน',
	section_information_password_update: 'เปลี่ยนรหัสผ่าน',
	section_information_social: 'การเชื่อมต่อกับโซเชียล',
	section_information_nosocial_message: 'คุณไม่มีบัญชีที่เชื่อมโยงไว้',
	section_information_firstname: 'ชื่อ',
	section_information_lastname: 'นามสกุล',
	section_information_birth: 'วันเกิด',
	section_information_country: 'ประเทศ/ภูมิภาค',
	section_information_postalcode: 'รหัสไปรษณีย์',
	section_information_edit: 'แก้ไข',
	section_tv_provider_title: 'ผู้ให้บริการทีวีของฉัน',
	section_tv_provider_desc: 'รับสิทธิ์เข้าถึงการแข่งขันสดและสตรีมจากผู้ให้บริการทีวีของคุณ',
	section_tv_provider_faq: 'คำถามเกี่ยวกับผู้ให้บริการทีวีที่พบบ่อย',
	section_tv_provider_sign_out: 'ออกจากระบบ',
	section_tv_provider_sign_in: 'เข้าสู่ระบบผู้ให้บริการทีวี',
	section_fantasy_title: 'Fantasy',
	section_fantasy_desc: 'ดูข้อมูลบัญชีแฟนตาซีของคุณ',
	section_fantasy_displayname: 'ชื่อที่ใช้แสดง',
	section_marketing_title: 'การตั้งค่าอีเมล',
	section_marketing_desc: 'ดูการสื่อสารการตลาดและการตั้งค่าความเป็นส่วนตัวของผู้ใช้',
	section_marketing_newsletters: 'จดหมายข่าว',
	section_marketing_message: 'ข้อความ NBA และโฆษณา',
	section_marketing_newsletters_desc_1: 'ข่าว NBA ที่ส่งถึงกล่องจดหมายของคุณทุกวัน',
	section_marketing_newsletters_desc_2: 'ข่าวสารและรายการพิเศษ NBA G League จากลีกรองอย่างเป็นทางการของ NBA',
	section_marketing_newsletters_desc_3: 'ข่าวสารและเนื้อหาของ Jr. NBA จากการริเริ่มบาสเกตบอลเยาวชนของ NBA',
	section_marketing_newsletters_desc_4: 'คุณสมบัติล่าสุดในแอป NBA รวมถึงการอัปเดตและข้อเสนอ League Pass',
	section_marketing_newsletters_desc_5: 'ข้อเสนอตั๋วพิเศษ ข้อเสนอพันธมิตร กิจกรรมต่างๆ และส่วนลดสินค้าจาก NBA',
	section_marketing_newsletters_desc_6: 'ข่าวสารและเนื้อหาของ NBA ที่คัดสรรกับมือ จะถูกส่งไปยังกล่องจดหมายของคุณทุกสัปดาห์',
	section_marketing_newsletters_desc_7: 'ข่าวสารและข้อเสนอของ WNBA จาก WNBA และพันธมิตรของ WNBA',
	section_marketing_personal_title: 'ข้อมูลส่วนบุคคลของฉัน',
	section_marketing_personal_desc: 'NBA สามารถใช้ข้อมูลส่วนบุคคลของฉันในการส่งข้อความและโฆษณา เกี่ยวกับผลิตภัณฑ์และโครงการต่างๆ ของ NBA และพันธมิตร NBA',
	section_marketing_update_button: 'อัปเดตการตั้งค่าทางการตลาด',
	section_marketing_update_success: 'อัปเดตการตั้งค่าแล้ว',
	section_ccpa_title: 'ห้ามขายข้อมูลส่วนบุคคลของฉัน',

	// profile edit modal
	email_modal_title: 'อัปเดตที่อยู่อีเมล',
	email_modal_new_email_label: 'ที่อยู่อีเมลใหม่',
	email_modal_update: 'อัปเดต',
	email_modal_cancel: 'ยกเลิก',
	password_modal_title: 'เปลี่ยนรหัสผ่าน',
	password_modal_current_label: 'รหัสผ่านปัจจุบัน:',
	password_modal_new_label: 'รหัสผ่านใหม่:',
	password_modal_confirm_label: 'ยืนยันรหัสผ่าน',
	password_modal_update: 'อัปเดต',
	password_modal_cancel: 'ยกเลิก',
	personal_modal_title: 'อัปเดตข้อมูลส่วนบุคคล',
	personal_modal_email: 'อีเมล',
	personal_modal_password: 'รหัสผ่าน',
	personal_modal_birth: 'วันเกิด',
	personal_modal_social: 'การเชื่อมต่อกับโซเชียล',
	personal_modal_firstname: 'ชื่อ',
	personal_modal_lastname: 'นามสกุล',
	personal_modal_country: 'ประเทศ/ภูมิภาค',
	personal_modal_postalcode: 'รหัสไปรษณีย์',
	personal_modal_zipcode: 'รหัสไปรษณีย์',
	personal_modal_postalcode_invalid_message: 'ต้องเป็นรหัสไปรษณีย์ที่ถูกต้อง',
	personal_modal_zipcode_invalid_message: 'ต้องเป็นรหัสไปรษณีย์ที่ถูกต้อง',
	personal_modal_update: 'อัปเดต',
	personal_modal_cancel: 'ยกเลิก',

	// payflow
	payflow_profile_name: 'ชื่อ:',
	payflow_profile_email: 'อีเมล',

	// account page
	header_menu_account_my_account: 'บัญชีของฉัน',
	header_menu_account_manage_account: 'จัดการบัญชี',
	header_menu_account_favorite_teams: 'ทีมโปรด',
	header_menu_account_favorite_players: 'ผู้เล่นคนโปรด',
	header_menu_account_viewing_history: 'ประวัติการเข้าชม',
};
